import { Injectable } from '@angular/core';
import { AppTableColumn, ColumnPreference } from '../_models/models';
import { LocalStorageService } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class ColumnPreferencesService {
  constructor(private localStorage: LocalStorageService) {}

  read(storageKey: string): ColumnPreference[] {
    return this.localStorage.readArray<ColumnPreference>(storageKey);
  }

  applyToColumns(columns: AppTableColumn[], storageKey: string): AppTableColumn[] {
    if (!columns || !storageKey) {
      return columns;
    }
    const prefsById = new Map(this.read(storageKey).map(pref => [pref.id, pref.isHidden]));
    if (prefsById.size === 0) {
      return columns;
    }
    return columns.map(col => {
      const savedIsHidden = prefsById.get(col.id);
      return savedIsHidden === undefined ? col : { ...col, isHidden: savedIsHidden };
    });
  }

  persist(storageKey: string, columns: AppTableColumn[]): void {
    if (!storageKey) {
      return;
    }
    const mergedById = new Map<string | number, ColumnPreference>(
      this.read(storageKey).map(pref => [pref.id, pref])
    );
    columns
      .filter(col => col.columnGroup)
      .forEach(col => mergedById.set(col.id, { id: col.id, isHidden: !!col.isHidden }));
    this.localStorage.write(storageKey, [...mergedById.values()]);
  }
}
